import { Box, Stack } from '@mui/material';
import { useAppSelector } from 'core/store/hooks';
import { MutableRefObject, useState } from 'react';
import Claim from '../Claim';
import FilterHelper from '../Claim/components/ClaimSummary/FilterHelper';
import { PublishedSinceDates, SourceDates } from '../helpers';
import ResultsHeader from '../ResultsHeader';

const getTotalMissingSourcesLength = ({
  claims,
  filteredClaims,
}: {
  claims: Claim[];
  filteredClaims: Claim[];
}) => {
  const differences = claims.map((item, index) => {
    const originalLength = item.evidence?.length ?? 0;
    const filteredLength = filteredClaims[index]?.evidence?.length ?? 0;
    return originalLength - filteredLength;
  });

  const totalMissing = differences.reduce((sum, currentDiff) => sum + currentDiff, 0);

  return totalMissing;
};

interface ClaimsProps {
  scrollTargetRef: MutableRefObject<HTMLDivElement | null>;
}

const Claims = ({ scrollTargetRef }: ClaimsProps) => {
  const claims = useAppSelector((state) => state.claimsV2.claims);
  const filteredClaims = useAppSelector((state) => state.claimsV2.filteredClaims) ?? claims;
  const selectedSearchEngines = useAppSelector(
    (state) => state.sourceFilterV2.selectedSearchEngines
  );

  const selectedPublishedSince = useAppSelector(
    (state) => state.sourceFilterV2.selectedPublishedSince
  );

  const selectedSourceDate = useAppSelector((state) => state.sourceFilterV2.selectedSourceDate);
  const [expandedClaim, setExpandedClaim] = useState<string | null>(null);

  const isFilterAdjusted =
    selectedSearchEngines?.length > 0 ||
    selectedSourceDate !== SourceDates.MOST_RECENT ||
    selectedPublishedSince !== PublishedSinceDates.ANY;

  const claimsArray = isFilterAdjusted ? filteredClaims : claims;
  const claimsLength = claimsArray.length;

  const numberOfmissingSources = getTotalMissingSourcesLength({ claims, filteredClaims });

  return (
    <Box>
      {claimsLength > 0 && (
        <ResultsHeader claimsLength={claimsLength} isFilterAdjusted={isFilterAdjusted} />
      )}
      {isFilterAdjusted && <FilterHelper numberOfmissingSources={numberOfmissingSources} />}
      <Stack ref={scrollTargetRef} display="flex" gap={2.5} direction="column">
        {claimsArray.map((claim, claimIndex) => {
          return (
            <Claim
              key={claimIndex}
              claimIndex={claimIndex}
              claim={claim}
              setExpandedClaim={setExpandedClaim}
              expandedClaim={expandedClaim}
            />
          );
        })}
      </Stack>
    </Box>
  );
};

export default Claims;
